<template>
  <div :class="['card', themeClass]">
    <div class="card-header">
      <img v-if="icon" :src="resolvedIcon" alt="Icon" class="card-icon" />
      <h3>{{ title }}</h3>
    </div>
    <div class="card-body">
      <p>{{ value }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardEChart",
  props: {
    title: String,
    value: [String, Number],
    icon: String,
    forceLight: { type: Boolean, default: false }
  },
  computed: {
    resolvedIcon() {
      try {
        return require(`${this.icon}`);
      } catch {
        return this.icon;
      }
    },
    themeClass() {
      // se veio forceLight, ignora darkmode do store
      if (this.forceLight) return "card--light"
      return this.$store.state.darkmode
        ? "card--dark"
        : "card--light"
    }
  }
};
</script>

<style scoped>
.card {
  width: 100%;
  height: 100%;
  max-height: 110px;
  padding: 20px;
  /* background-color: #1e1e2f; */
  /* box-shadow: 0 4px 15px rgba(0, 0, 0, 0.212); */
  border-radius: 14px;
  /* transition: transform 0.3s, box-shadow 0.3s; */
  overflow: hidden;
  /* border-color: #ffffff; */
  /* border: 1px solid; */
  margin-bottom: 0;
}

.card--dark {
  background-color: #1e1e2f;
  border: 1px solid #525f7f;
}

.card--light {
  background-color: #ffffff;
  border: 1px solid #525f7f;
  -webkit-box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0.1);
}

.card--light .card-header h3 {
  color: gray;
}

.card--light .card-body p {
  color: #1e1e2f;
}

.card--light .card-header img {
  color: #1e1e2f;
}

.card--dark .card-header h3,
.card--dark {
  color: gray;
}

.card-header {
  display: flex;
  align-items: center;
  margin-top: -19px;
}

.card-header h3 {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  flex: 1;
  color: gray;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.3;
}

.card-icon {
  width: 32px;
  height: 32px;
  margin-right: 10px;
  margin-left: -15px;
}

.card-body {
  font-size: 23px;
  color: #ffffff;
  line-height: 1.5;
  text-align: right;
}
</style>
